import React from "react";
import Header from "../../Header/Header";

const Help = () => {
  return (
    <>
        <Header />
        <div className="mx-4 mt-58">
            <p>Help Page</p>
        </div>
    </>
  );
};

export default Help;
